import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
// import careers from '../../../database/careers.json';
import apiService from '../../../features/api/service';

const allLabel = {
  en: 'All',
  id: 'Semua'
}

const NavItem = ({children, isSelected, ...props}) => {
  return <li className={`font-bold lg:text-lg mb-4 lg:mb-8 cursor-pointer ${isSelected ? '' : 'opacity-50'}`} {...props}>
    {children}
  </li>
}

const AccordionNav = () => {
  const history = useHistory()
  const location = useLocation()
  const language = useSelector(state => state.system.language)
  const [category, setCategory] = useState({})
  const categoryIds = Object.keys(category)
  const params = new URLSearchParams(location.search)
  const currentCategoryId = params.get('category')

  useEffect(() => {
    // let newCategory = {}
    // for (let index = 0; index < careers.length; index++) {
    //   const { category } = careers[index];

    //   if(category && category.id && !newCategory[category.id]){
    //     newCategory[category.id] = category
    //   }
    // }

    // setCategory(newCategory)

    // Fetch data
    apiService.get('careers')
      .then(res => {
        if(res.results){
          const newCategory = {}
          for (let index = 0; index < res.results.length; index++) {
            const element = res.results[index];
            const {
              kategori
            } = element

            if(!newCategory[kategori]){
              newCategory[kategori] = {
                id: index,
                name: {
                  en: kategori,
                  id: kategori
                }
              }
            }
          }
          setCategory(newCategory)
        }
      })
  }, [])

  const handleClick = (id) => {
    if(id){
      history.push(location.pathname + '?category=' + id)
    } else {
      history.push(location.pathname)
    }
  }

  return (
    <ul>
      <NavItem onClick={() => handleClick()} isSelected={!currentCategoryId}>
        {allLabel[language.name]}
      </NavItem>
      {
        categoryIds.map(id => (
          <NavItem key={id} onClick={() => handleClick(id)} isSelected={currentCategoryId === id}>
            {category[id].name[language.name]}
          </NavItem>
        ))
      }
    </ul>
  )
}

export default AccordionNav
